export default function(app) {
    let start = null
    let t = 0
    let dt = 0

    window.requestAnimationFrame(step)

    function step(timestamp) {
        if (!start) start = timestamp;
        t = timestamp - start;
        const millis = 1000.0

        if(t < millis) window.requestAnimationFrame(step)
        if(t > millis) t = millis

        dt = parseFloat(t)/parseFloat(millis)

        app.events.emit('kx_repaint', dt)
    }
}
